import PropTypes from 'prop-types';
import React from 'react';
import getData from './getData';

/**
 *  Breadcrumb Schema Component
 *
 */
function Breadcrumb(_ref) {
  let {
    config,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("script", Object.assign({
    "data-cmp": "breadcrumbSchema",
    type: "application/ld+json"
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: `${JSON.stringify(getData(config))}`
    }
  }, rest));
}
export default Breadcrumb;